/* eslint-disable react-hooks/exhaustive-deps */
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Table, Button, Modal, Form, Input, Switch } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import { showWarningNotification, showErrorNotification } from "../../../../utils/notification";

const VideoSectionUploadModal = ({ ROOT_URL, isModalOpen = false, setIsModalOpen = () => {} }) => {
  const TARGET_URL = "admin/cp-sheet/promotion-videos";
  const [form] = Form.useForm();
  const [videos, setVideos] = useState([]);
  const [editVideo, setEditVideo] = useState(null);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState();

  const fetchVideoSectionDetails = () => {
    axios
      .get(`${ROOT_URL}/${TARGET_URL}/list`)
      .then((res) => {
        setVideos(res.data.videosDetails);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleFormSubmit = (values) => {
    const videoDetails = {
      videoLink: values.videoLink,
      videoTitle: values.videoTitle,
      sequenceNumber: values.sequenceNumber,
      active: values.active
    };

    if (editVideo) {
      axios
        .put(`${ROOT_URL}/${TARGET_URL}/update`, {
          videoDetails: videoDetails,
          videoId: selectedVideoId
        })
        .then(() => {
          showWarningNotification("Video Updated Successfully");
          setVideoModalOpen(false);
          setEditVideo(null);
          fetchVideoSectionDetails();
        })
        .catch((err) => showErrorNotification(err));
    } else {
      axios
        .post(`${ROOT_URL}/${TARGET_URL}/create`, { videoDetails })
        .then(() => {
          showWarningNotification("New Video Added Successfully");
          setVideoModalOpen(false);
          fetchVideoSectionDetails();
        })
        .catch((err) => showErrorNotification(err));
    }
  };

  const handleDelete = () => {
    axios
      .put(`${ROOT_URL}/${TARGET_URL}/delete`, { videoId: selectedVideoId })
      .then(() => {
        showWarningNotification("Video Deleted Successfully");
        fetchVideoSectionDetails();
      })
      .catch((err) => showErrorNotification(err));
  };

  const handleToggleActive = (videoId, activeStatus) => {
    axios
      .put(`${ROOT_URL}/${TARGET_URL}/toggle-view`, {
        activeStatus: !activeStatus,
        videoId: videoId
      })
      .then(() => {
        showWarningNotification(`Video ${activeStatus ? "Deactivated" : "Activated"} Successfully`);
        fetchVideoSectionDetails();
      })
      .catch((err) => showErrorNotification(err));
  };

  const handleEdit = (video) => {
    setEditVideo(video);
    form.setFieldsValue({
      videoLink: video.videoLink,
      videoTitle: video.videoTitle,
      sequenceNumber: video.sequenceNumber,
      active: video.active
    });
    setVideoModalOpen(true);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "videoTitle",
      key: "videoTitle"
    },
    {
      title: "Link",
      dataIndex: "videoLink",
      key: "videoLink",
      render: (link) => (
        <a href={link} target="_blank" rel="noopener noreferrer">
          {link}
        </a>
      )
    },
    {
      title: "Sequence",
      dataIndex: "sequenceNumber",
      key: "sequenceNumber"
    },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: (active, record) => (
        <Switch checked={active} onChange={() => handleToggleActive(record._id, active)} />
      )
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div
          role="button"
          tabIndex={0}
          onClick={() => setSelectedVideoId(record._id)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              setSelectedVideoId(record._id);
            }
          }}
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
            style={{ marginRight: "8px" }}
          />
          <Button icon={<DeleteOutlined />} danger onClick={() => handleDelete()} />
        </div>
      )
    }
  ];

  useEffect(() => {
    fetchVideoSectionDetails();
  }, []);

  return (
    <>
      <Modal
        title="Manage Promotion Videos"
        open={isModalOpen}
        footer={[]}
        style={{ minWidth: "max-content" }}
        onCancel={() => setIsModalOpen(false)}
      >
        <Button
          type="primary"
          icon={<PlusOutlined />}
          style={{ marginBottom: "10px" }}
          onClick={() => {
            form.resetFields();
            setEditVideo(null);
            setVideoModalOpen(true);
          }}
        >
          Add New Video
        </Button>

        <Table
          columns={columns}
          dataSource={videos}
          bordered
          pagination
          rowKey={(record) => record._id}
          scroll={{ x: "max-content" }}
        />
      </Modal>

      {/* Create/Edit Video Modal */}
      <Modal
        title={editVideo ? "Edit Video" : "Add New Video"}
        open={videoModalOpen}
        footer={null}
        onCancel={() => setVideoModalOpen(false)}
      >
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Form.Item
            name="videoTitle"
            label="Video Title"
            rules={[{ required: true, message: "Please enter the video title" }]}
          >
            <Input placeholder="Enter video title" />
          </Form.Item>
          <Form.Item
            name="videoLink"
            label="Embedd Video Link"
            rules={[
              {
                required: true,
                message: "Please enter the embed video link"
              },
              () => ({
                validator(_, value) {
                  if (!value.includes("youtube.com/embed")) {
                    return Promise.reject("Please enter a valid embed link");
                  }
                  return Promise.resolve();
                }
              })
            ]}
          >
            <Input placeholder="Enter video link" />
          </Form.Item>
          <Form.Item
            name="sequenceNumber"
            label="Sequence Order"
            rules={[{ required: true, message: "Please enter sequence order" }]}
          >
            <Input type="number" placeholder="Enter sequence number" />
          </Form.Item>
          <Form.Item name="active" label="Active" valuePropName="checked">
            <Switch defaultChecked />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {editVideo ? "Update Video" : "Create Video"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default VideoSectionUploadModal;
